import { useEffect, useState } from "react";
import { FormHolidays } from "../components/FormHolidays";
import { IHoliday } from "../../../../@types/holiday.type";
import { useNavigate, useParams } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import { toast } from "react-toastify";
import { IApiResponse } from "../../../../@types/api-response.type";
import { getHolidayById } from "../../../../services/api/holidays/holidaysService";
import usePermission from "../../../../hooks/usePermission";
import { FeatureStatic } from "../../../../@types/statics/feature.static";

export const UpdateHoliday: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [holiday, setHoliday] = useState<IHoliday>({} as IHoliday);
  const { id } = useParams();
  const navigate = useNavigate();
  const permissions = usePermission(FeatureStatic.holidays.id);

  useEffect(() => {
    if (!permissions.canView()) {
      navigate("/unauthorized");
      return;
    }

    async function fechHolidayById() {
      try {
        setLoading(true);

        if (!id) {
          toast.error("ID do Feriado não fornecido!");
          navigate("/*");
          return;
        }

        const response = (await getHolidayById(id)) as IApiResponse<IHoliday>;

        if (!response.result) {
          toast.error("Feriado não encontrado!");
          navigate("/*");
          return;
        }

        setHoliday(response.result);
      } catch (error) {
        console.log(error);
        toast.error("Erro ao carregar o Feriado!");
      } finally {
        setLoading(false);
      }
    }

    fechHolidayById();
  }, [id]);

  return (
    <>
      {loading ? (
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        >
          <CircularProgress size={100} />
        </div>
      ) : (
        <div>
          <FormHolidays pageType="update" holidayData={holiday} />
        </div>
      )}
    </>
  );
};
